{
    "name": "@recursyve/angular-seed",
    "version": "1.0.0",
    "scripts": {
        "ng": "ng",
        "start": "ng serve --open",
        "build": "ng build",
        "build:prod": "ng build",
        "build:staging": "ng build -c staging",
        "generate:openapi": "ng-openapi-gen --config openapi-gen.config.json",
        "test": "ng test",
        "sort-json": "find \"$(pwd)\" -type f \\( -name \"en.json\" -o -name \"fr.json\" \\) -exec sort-json {} \\;",
        "lint": "ng lint",
        "bundle-report": "ng build && source-map-explorer \"dist/**/*.js\" --no-border-checks",
        "deploy:staging": "firebase deploy --only hosting:local144-dev",
        "deploy:prod": "firebase use local144-prod && firebase deploy --only hosting:local144-prod",
        "sentry:sourcemaps": "sentry-cli sourcemaps inject --org recursyve --project local144-angular ./dist && sentry-cli sourcemaps upload --org recursyve --project local144-angular ./dist",
        "prepare": "cd .. && npm run prepare"
    },
    "private": true,
    "dependencies": {
        "@angular-architects/ngrx-toolkit": "^21.0.1",
        "@angular/animations": "^22.1.2",
        "@angular/cdk": "^22.1.2",
        "@angular/common": "^22.1.2",
        "@angular/compiler": "^22.1.2",
        "@angular/core": "^22.1.2",
        "@angular/fire": "^21.0.0-rc.0",
        "@angular/forms": "^22.1.2",
        "@angular/material": "^22.1.2",
        "@angular/material-moment-adapter": "^22.1.2",
        "@angular/platform-browser": "^22.1.2",
        "@angular/platform-browser-dynamic": "^22.1.2",
        "@angular/router": "^22.1.2",
        "@jsverse/transloco": "^8.2.1",
        "@material/material-color-utilities": "0.3.0",
        "@ngneat/overview": "7.0.0",
        "@ngrx/signals": "^21.1.1",
        "@ngxpert/hot-toast": "^6.1.0",
        "@recursyve/ngx-material-components": "^22.2.0",
        "@recursyve/ngx-navigation": "^22.0.1",
        "@recursyve/nice-filter-view": "^22.0.0",
        "@recursyve/nice-ts-utils": "^0.0.3",
        "@sentry/angular": "^10.34.0",
        "@sentry/cli": "^2.58.4",
        "@sentry/tracing": "^7.120.4",
        "@tailwindcss/container-queries": "^0.1.1",
        "angularx-qrcode": "^21.0.5",
        "class-variance-authority": "^0.7.1",
        "clsx": "^2.1.1",
        "date-fns": "^4.1.0",
        "firebase": "^9.9.2",
        "lodash-es": "^4.17.23",
        "moment": "^2.30.1",
        "ngx-dropzone": "^3.0.0",
        "ngx-gravatar": "^13.0.0",
        "ngx-infinite-scroll": "^21.0.0",
        "ngx-mask": "^20.0.3",
        "qrcode": "^1.5.4",
        "rxjs": "^7.5.5",
        "tailwind-merge": "^3.4.0",
        "tailwindcss": "^3.4.19",
        "tslib": "^2.4.0",
        "uuid": "^9.0.0"
    },
    "devDependencies": {
        "@angular-devkit/core": "^22.1.4",
        "@angular/build": "^22.1.4",
        "@angular/cli": "^22.1.4",
        "@angular/compiler-cli": "^22.1.2",
        "@angular/language-service": "^22.1.2",
        "@jsverse/transloco-schematics": "^8.2.1",
        "@total-typescript/ts-reset": "^0.6.1",
        "@types/lodash-es": "^4.17.12",
        "@types/node": "^24.10.7",
        "@types/qrcode": "^1.5.5",
        "@vitest/browser-playwright": "^4.1.10",
        "@vitest/eslint-plugin": "^1.6.27",
        "angular-eslint": "^22.1.0",
        "eslint": "^9.39.2",
        "firebase-tools": "^14.27.0",
        "ng-openapi-gen": "^1.0.5",
        "playwright": "^1.62.1",
        "postcss": "^8.4.14",
        "sort-json": "^2.0.1",
        "source-map-explorer": "^2.5.3",
        "ts-node": "~10.8.1",
        "tsc-files": "^1.1.4",
        "typescript": "~6.0.3",
        "typescript-eslint": "8.65.0",
        "vitest": "^4.1.10",
        "yaml": "^2.8.2"
    }
}
